<app-file-drop
    [externalErrors]="errors"
    [allowedTypes]="['.csv', '.tsv', '.ods', '.xlsx', '.xls']"
    (filesSelected)="onFileChange($event)"
>
</app-file-drop>
<input name="fileUploaded" required type="hidden" [(ngModel)]="hasFile" />
